import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

function BillDetail({ title, text }) {
  return (
    <div style={styles.container}>
      {text && [
        <UTLabel key={title} semibold style={styles.titleDetail}>
          {title}
        </UTLabel>,
        <UTLabel key={text} darkGray light>
          {text}
        </UTLabel>
      ]}
    </div>
  );
}

BillDetail.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string
};

export default Radium(BillDetail);
